var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.83643C7.58172 4.83643 4 8.41815 4 12.8364C4 17.2547 7.58172 20.8364 12 20.8364C16.4183 20.8364 20 17.2547 20 12.8364C20 8.41815 16.4183 4.83643 12 4.83643ZM2 12.8364C2 7.31358 6.47715 2.83643 12 2.83643C17.5228 2.83643 22 7.31358 22 12.8364C22 18.3593 17.5228 22.8364 12 22.8364C6.47715 22.8364 2 18.3593 2 12.8364ZM12 6.83643C12.5523 6.83643 13 7.28414 13 7.83643V13.8364C13 14.3887 12.5523 14.8364 12 14.8364C11.4477 14.8364 11 14.3887 11 13.8364V7.83643C11 7.28414 11.4477 6.83643 12 6.83643ZM11 17.8364C11 17.2841 11.4477 16.8364 12 16.8364H12.009C12.5613 16.8364 13.009 17.2841 13.009 17.8364C13.009 18.3887 12.5613 18.8364 12.009 18.8364H12C11.4477 18.8364 11 18.3887 11 17.8364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.71a8633ae27a9be2fd869f3a5eddba92.svg";
export { ForwardRef as ReactComponent };